import React from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

export const BUTTON_COLORS = {
  primary: "#09617e",
  secondary: "#6B7280", 
  success: "#22C55E",
  warning: "#F59E0B",
  danger: "#EF4444",
  purple: "#8B5CF6",
  pink: "#EC4899",
  black: "#111827",
  white: "#FFFFFF",
};

const BackButton = ({
  size = "large",
  color = "primary",
  children = "Back",
  ...props
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const selectedColor = BUTTON_COLORS[color] || BUTTON_COLORS.primary;

  return (
    <Button
      size={size}
      onClick={handleBack}
      style={{
        backgroundColor: selectedColor,
        borderColor: selectedColor,
        color: color === "white" ? "#000" : "#fff",
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default BackButton;
